
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.333 2.282v4.454c0 .92.688 1.674 1.557 1.733l.11.003h2.943A1.004 1.004 0 016 9.168H3.667c-1.105 0-2-.933-2-2.083v-3.82c0-.454.278-.84.666-.982zm5-1.449c.552 0 1 .467 1 1.042v4.861c0 .576-.448 1.042-1 1.042H4c-.552 0-1-.466-1-1.042v-4.86C3 1.3 3.448.832 4 .832h3.333zm0 .695H4a.34.34 0 00-.333.347v4.861c0 .192.149.348.333.348h3.333a.34.34 0 00.333-.348v-4.86a.34.34 0 00-.333-.348z","fill":"#9DA7B2"}})])
          )
        }
      }
    